import React from 'react';
import { useTranslation } from 'react-i18next';
import ProjectCard from '../ProjectCard';
import { projects } from '../../data/projects';

const Projects: React.FC = () => {
  const { i18n } = useTranslation();
  const isPt = i18n.language.startsWith('pt');

  return (
    <section id="projects" className="game-section">
      <div className="game-section__inner">
        <header className="game-section__header">
          <div>
            <span className="game-section__kicker">03 // {isPt ? 'PROJETOS' : 'PROJECTS'}</span>
            <h2>{isPt ? 'Projetos selecionados.' : 'Selected projects.'}</h2>
          </div>
          <p>
            {isPt
              ? 'Uma seleção de entregas públicas em backend, inteligência artificial, aplicações web, algoritmos e ferramentas para desenvolvedores.'
              : 'A selection of public work across backend, artificial intelligence, web apps, algorithms, and developer tooling.'}
          </p>
        </header>

        <div className="game-mission-grid">
          {projects.map((project, index) => (
            <ProjectCard project={project} index={index} key={project.title} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
